module.exports = __webpack_public_path__ + "static/img/top_img.b23917c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/view/top_img.png
// module id = eGba
// module chunks = 1